<template>
	<div class="hierarchy-items">
		<job-hierarchy-level
			v-for="(assignation, index) of hierarchyAssignation"
			:assignation="assignation"
			:key="index"
			:level="assignation.originalLevel !== undefined ? assignation.originalLevel : index"
			:selected-job-position='selectedJobPosition'
			:selected-level="selectedJobPositionLevel"
			:filtered-area-id="filteredAreaId"
			@selectedJobPosition="$emit('selectedJobPosition', $event)"
		@close="$emit('close')"
		/>
	</div>
</template>

<script>
import JobHierarchyLevel from '@/modules/job-evaluation/components/supplies/guideline-model/hierarchy/hierarchy-assignation/job-hierarchy-level';

export default {
	name: 'job-hierarchy-form',
	components: { JobHierarchyLevel },
	props: ['hierarchyAssignation', 'selectedJobPosition', 'selectedJobPositionLevel', 'filteredAreaId'],
};
</script>

<style lang="scss" scoped>
.hierarchy-items {
	div.hierarchy-item:last-child {
		border: none;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/hierarchy/job-hierarchy-form.vue